
import React ,{ Component } from 'react';
import {Container, Row, Col,Image,Button  } from 'react-bootstrap';
import "./EventsAndActivities.css";
import { withRouter,Link } from "react-router-dom";
import { getCampaignAPICallData } from '../../services/MemberService';
import ShowAllPhotos from './ShowAllPhotos';

class AttendedPhotosSection extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ShowAllPhotosModal:false
        }
    }


    showAllAttendedPhotosBlock = () => {
        this.setState({ShowAllPhotosModal:true});
    }

  
    render() {
        return (
            <>
            <Row>
                <Col sm={12} className="mt-3">
                    <h6 className='f-14  fw-bold mb-0'>ATTENDEES PHOTOS {this.props.stateData.attenedPhotosList.length == 0 ? "" : <b className='event_headings_color'> : {this.props.stateData.attenedPhotosList.length}</b>}</h6>
                        {
                            this.props.stateData.attenedPhotosList.length == 0 ?
                            (
                                this.props.stateData.attendedPhotosCheck == 1 ?
                                (<h6 className='f-14 text-center mt-2'>Attendance Photos Not Available...</h6>)
                                :
                                (
                                    <Col sm={12}>
                                        <div class="spinner-border color_yellow loading-img-center mt-4"></div>
                                    </Col>
                                )
                                
                            )
                            :
                            (
                                this.props.stateData.attenedPhotosList.length>0 ?
                                (

                                    <Col sm={12}>
                                        <div className='photos_gallery_flex'>
                                            {
                                                this.props.stateData.attenedPhotosList.slice(0, 3).map((item,index) => {
                                                return(
                                                        <div onClick={() => this.showAllAttendedPhotosBlock()} className="cursor_pointer"><Image src={item.filePath} alt={item.fileName} className="width_height_photo"></Image></div>
                                                )
                                                })
                                                
                                            }
                                        </div>
                                        {
                                            this.props.stateData.attenedPhotosList.length>3 ?
                                            (<div className='mt-1 f-14 fw-bold cursor_pointer float-end' onClick={() => this.showAllAttendedPhotosBlock()}>View More...</div>)
                                            :
                                            ("")
                                        }
                                    </Col>

                                )
                                :
                                ("")
                            )
                        }
                </Col>
            </Row>
            {
                this.props.stateData.attenedPhotosList.length>0 ?
                (
                    <ShowAllPhotos 
                        show={this.state.ShowAllPhotosModal}
                        onHide={() => this.setState({ ShowAllPhotosModal: false })}
                        getAllPhotosList={this.props.stateData.attenedPhotosList}
                        modalTitle="Attended"
                    />
                )
                :
                ("")
            }
            
            </>
        )
    }
  }
  
  export default withRouter(AttendedPhotosSection);
  